import { AddProductModal } from './AddProductModal';

export default AddProductModal;
